export default __webpack_public_path__ + "static/media/leftBox.1ff5197b.png";